import React from 'react';
import { IBasePickerSuggestionsProps, ITag, Label, TagPicker } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

import styles from './ResponsiblePicker.module.scss';

export interface Props {
	responsible: string[];
	onChange: (text: string) => void;
	error?: string;
}

export const ResponsiblePicker = (props: Props) => {
	const { t } = useTranslation();

	const responsibleTags: ITag[] = props.responsible.map((r) => {
		return { key: r, name: r };
	});

	const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
		suggestionsHeaderText: t('responsible.suggestions'),
		noResultsFoundText: t('responsible.noresponsible'),
	};

	const listContainsTagList = (tag: ITag, tagList?: ITag[]) => {
		if (!tagList || !tagList.length || tagList.length === 0) {
			return false;
		}
		return tagList.some((compareTag) => compareTag.key === tag.key);
	};

	const filterSuggestedTags = (filterText: string, tagList: ITag[] | undefined): ITag[] => {
		return filterText
			? responsibleTags.filter(
					(tag) => tag.name.toLowerCase().indexOf(filterText.toLowerCase()) !== -1 && !listContainsTagList(tag, tagList)
			  )
			: [];
	};

	const showAllSuggestedTags = (items?: ITag[] | undefined): ITag[] | PromiseLike<ITag[]> => {
		return responsibleTags;
	};

	const changeItem = (items?: ITag[] | undefined) => {
		if (!items || items.length === 0) {
			props.onChange('');
			return;
		}
		props.onChange(String(items[0].key));
	};

	return (
		<div>
			<Label required={true}>{t('responsible.label')}</Label>
			<TagPicker
				pickerSuggestionsProps={pickerSuggestionsProps}
				onChange={changeItem}
				onResolveSuggestions={filterSuggestedTags}
				onEmptyResolveSuggestions={showAllSuggestedTags}
				itemLimit={1}
			/>
			{props.error !== '' ? <div className={styles.errorText}>{props.error}</div> : <></>}
		</div>
	);
};
